import { inject, Injectable, signal } from '@angular/core';
import { IPlace } from '@okcargo-apps/shared-domain-ionic';
import { PlaceQueryService } from '@okcargo-apps/shared-infrastructure-ionic';
import { SearchPlacesQuery } from '@okcargo/query-processor';
import { catchError, EMPTY, finalize, from, Observable, of, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlaceService {
  private readonly addressQueryService = inject(PlaceQueryService);

  public readonly searchPlacesLoading = signal(false);

  // constructor() {}

  public searchPlaces$(term: string, countryCode = 'ES'): Observable<IPlace[]> {
    if (!term || term.trim().length < 2) {
      return EMPTY;
    }

    term = term.trim();

    const query = {
      countryCode: countryCode,
      city: term,
      postalCode: term,
    } as SearchPlacesQuery;

    this.searchPlacesLoading.set(true);

    return from(this.addressQueryService.searchPlaces(query)).pipe(
      timeout(5000),
      catchError((error) => {
        // TODO implement error message
        // if (error instanceof TimeoutError) { ... }
        return of([]); // empty list on error
      }),
      finalize(() => {
        this.searchPlacesLoading.set(false);
      }),
    );
  }
}
